exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".outer {\n    padding-top: 30px;\n    padding-bottom: 10px;\n    position: relative;\n    /* bottom: 0; */\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: space-evenly;\n        -ms-flex-pack: space-evenly;\n            justify-content: space-evenly;\n}\n\n.outer div a {\n    font-weight: bold;\n    color: white;\n    -webkit-box-flex: 0;\n        -ms-flex: none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'> ];\n            flex: none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'> ]\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/structural_components/footer/footer-links/footer-links.component.css
// module id = 380
// module chunks = 1